import type { Variables, Cache, UpdatesConfig } from '@urql/exchange-graphcache';

import type { KaminoPaymentMethodSaveMutation } from '../../generated/graphql';

import invalidateQuery from '~/graphql/mma/config/util/invalidateQuery';

const updateRentersPaymentMethod: UpdatesConfig['Mutation'] = {
  kaminoPaymentMethodSave: (data: KaminoPaymentMethodSaveMutation, _: Variables, cache: Cache) => {
    if (data.kaminoPaymentMethodSave) {
      invalidateQuery('kaminoPaymentMethod', cache);
    }
  },
};

export default updateRentersPaymentMethod;
